import React from 'react';
import Button from '@mui/material/Button';
import WelcomeContent from './WelcomeContent';

export const LimitReached: React.FC = () => {
  return (
    <div className="cn-welcome-container">
      <div className="cn-welcome-content">
        <div className="cn-welcome-logos">
          <a
            href="https://www.charitynavigator.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/cn-logo.png" alt="Charity Navigator" />
          </a>
          <a
            href="https://www.trueimpact.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/logo_primary.png" alt="True Impact" />
          </a>
        </div>

        <h1 className="cn-welcome-title">Thank You for Your Interest</h1>

        <div className="cn-welcome-message">
          <p>
            Thank you for your interest in creating an Impact Report! We're not
            currently accepting new impact reports but please come back soon.
            We'll be accepting new reports soon.
          </p>
        </div>
      </div>
    </div>
  );
};

const WelcomeScreenContent: React.FC<{ onContinue: () => unknown }> = ({
  onContinue,
}) => {
  return (
    <div className="cn-welcome-container">
      <div className="cn-welcome-content">
        <div className="cn-welcome-logos">
          <a
            href="https://www.charitynavigator.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/cn-logo.png" alt="Charity Navigator" />
          </a>
          <a
            href="https://www.trueimpact.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/logo_primary.png" alt="True Impact" />
          </a>
        </div>

        <h1 className="cn-welcome-title">
          Welcome to the Impact Report Builder
        </h1>
        <p className="cn-welcome-subtitle">Powered by True Impact</p>

        <div className="cn-welcome-message">
          <p>
            In the Impact Report Builder, you'll be asked to select one program
            and report on its activities, reach, and impact using clear, guided
            prompts. Once published, your report will receive credit for
            completion, and we'll evaluate your program's cost per outcome and
            data quality as part of your Encompass Rating. Once published, your
            report will be available for download via the nonprofit portal.
          </p>
        </div>

        <div className="cn-welcome-video">
          {/* TODO: Replace with actual video link when provided by Jessica */}
          <iframe
            src="https://www.youtube.com/embed/6JqKZoufnIg"
            title="Welcome to Impact Reporting"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <div className="cn-welcome-button-container">
          <Button
            onClick={onContinue}
            variant="contained"
            color="primary"
            size="large"
            className="cn-welcome-continue-button"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

/**
 * Welcome screen for Charity Navigator partnership
 */
type WelcomeScreenProps = {
  onContinue: () => unknown;
  isLimitReached?: boolean;
};

export default function WelcomeScreen({
  onContinue,
  // isLimitReached = false,
}: WelcomeScreenProps) {
  // if (isLimitReached) {
  //   return <LimitReached />;
  // }

  // return <WelcomeScreenContent onContinue={onContinue} />;
  return <WelcomeContent onContinue={onContinue} />;
}
